// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"7a84f46d","453":"a3c07c60"}[chunkId] + ".chunk.js");